/**
 * UTM and Google-documented tracking query parameter matchers that should be preserved across the accesso ID
 * sign-in round trip and in-app navigation. Entries are either an exact key match (`string`) or a `RegExp`
 * tested against the key.
 */
export const TRACKING_QUERY_PARAM_PATTERNS: readonly (string | RegExp)[] = [
	// Any UTM (Urchin Tracking Module) campaign parameter, e.g. utm_source, utm_medium, utm_campaign
	/^utm_\w+$/,
	// Google Analytics client id / cross-domain linker - https://support.google.com/analytics/answer/11197805
	'_ga',
	'_gl',
	// Google Ads / Display & Video 360 / Privacy Sandbox click identifiers - https://support.google.com/google-ads/answer/9744275
	'gclid',
	'gclsrc',
	'dclid',
	'gbraid',
	'wbraid',
];

/**
 * Determines whether a query parameter key is a recognized UTM or Google tracking parameter that should be
 * preserved across navigation and the accesso ID sign-in round trip.
 * @param key The query parameter key to check
 * @returns True if the key matches one of the known tracking parameter patterns
 */
export function isTrackingQueryParam(key: string): boolean {
	return TRACKING_QUERY_PARAM_PATTERNS.some((pattern) => (typeof pattern === 'string' ? pattern === key : pattern.test(key)));
}
